import React from 'react';
import { Button, Card, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Sticker from '../../../assets/images/cooking-club-sticker.png';
import { Course } from '../../../types/course.type';
import { generateFileUrlSegment } from '../../../utils/utils';
import { CourseDateTimes, CourseClassCountAndFormat, course_type_style_lookup } from './CourseDates';
import { CourseVenue } from './CourseVenue';

export const course_type_card_style_lookup = (key: string) => {
  switch (key) {
    case 'after_school':
      return 'pink';
    case 'camp':
      return 'orange';
    case 'event':
      return 'green';
    default:
      return 'primary';
  }
};

export interface CourseCardSimpleProps {
  course: Course;
  selected?: boolean;
  onClose?: () => void;
  onClick?: () => void;
}

export const CourseCardSimple: React.FC<CourseCardSimpleProps> = ({
  course,
  selected,
  onClose,
  onClick
}) => {
  const navigate = useNavigate();

  let className = course_type_card_style_lookup(course.course_type);
  let fillStyle = course_type_style_lookup(course.course_type);

  const enrollment = course.enrollment?.split('/');
  const enrolled = +enrollment?.[0];
  const capacity = +enrollment?.[1];
  const seatsLeft = capacity - enrolled;
  const registerAtVenue = course.payment_type === 'onsite';
  const isSoldOut = !registerAtVenue && !isNaN(capacity) && capacity > 0 && enrolled >= capacity;
  const showSeatsLeft = !registerAtVenue && !isNaN(capacity) && capacity > 0 && !isSoldOut && seatsLeft < 5;

  const featuredImage = course.theme?.theme_images?.find((img) => !!img.is_featured);
  const logoSrc = featuredImage
    ? `${generateFileUrlSegment(featuredImage.id, featuredImage.s3_base_url, 'medium')}/${featuredImage.image_file_name}`
    : Sticker;

  return (
    <Card
      className={`course-card-simple m-1 shadow ${className}`}
      onClick={() => (selected ? undefined : onClick?.())}
    >
      <Card.Body>
        <Stack gap={1}>
          <div className="text-center d-none d-lg-block">
            <img
              className="course-card-simple-logo"
              src={logoSrc}
              height={130}
              width={130}
              alt=""
              onError={(e) => {
                (e.target as HTMLImageElement).src = Sticker;
              }}
            />
          </div>
          <Stack direction="horizontal">
            <Stack gap={1}>
              <Card.Subtitle className={`course-card-title ${className}`}>
                {course.title}
              </Card.Subtitle>
              <CourseDateTimes course={course} />
              <CourseClassCountAndFormat course={course} />
              <CourseVenue
                course={course}
                color={className}
                fillStyle={fillStyle}
              />
            </Stack>
          </Stack>
          <Stack gap={1}>
            {isSoldOut ? (
                <span className="text-uppercase fw-bold" style={{ color: '#B81F69', fontSize: '.75rem' }}>
                Sold Out
              </span>
            ) : showSeatsLeft && (
                <span className="text-muted" style={{ fontSize: '.875rem' }}>
                Only {seatsLeft} {seatsLeft === 1 ? 'seat' : 'seats'} left
              </span>
            )}
            <Stack direction="horizontal">
              <Button
                  variant={isSoldOut ? 'outline-primary' : 'primary'}
                  size="sm"
                  className={'text-uppercase form-control mx-2 my-1'}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/sessions/${course.slug ?? course.id}`);
                  }}
              >
                {isSoldOut ? 'Join the Waitlist' : 'View Details'}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
};
